import { actionTypes } from "./storeTypes";

export const init_local = {
  vsfp: { rawdata: [] },
  vsfpFiltered: [],
  filter: {
    Ticker: [],
    ModelDate: [],
    Horizon: [],
  },
  filterDefaults: {
    Ticker: [],
    ModelDate: [],
    Horizon: [],
  },
  loading: true,
};

export function local_reducer(state, action) {
  switch (action.type) {
    case actionTypes.SET_VSFP: {
      return {
        ...state,
        vsfp: action.payload,
      };
    }
    case actionTypes.SET_VSFP_FILTERED: {
      return {
        ...state,
        vsfpFiltered: action.payload,
      };
    }
    case actionTypes.SET_FILTER: {
      return {
        ...state,
        filter: action.payload,
      };
    }
    case actionTypes.SET_FILTER_DEFAULTS: {
      return {
        ...state,
        filterDefaults: action.payload,
      };
    }
    case actionTypes.SET_LOADING: {
      return {
        ...state,
        loading: action.payload,
      };
    }
    default:
      return state;
  }
}
